
export const ContractSignOption = {
    Signed: 0,
    ToBeSigned: 1
} as const

export type ContractSignOption = typeof ContractSignOption[keyof typeof ContractSignOption]


export const ContractSignOptions: [ContractSignOption, string][] = [
    [ContractSignOption.Signed, 'Pojistná smlouva byla podepsána dne:'],
    [ContractSignOption.ToBeSigned, 'K podpisu pojistné smlouvy dojde dle naší dohody dne:']
]

export const getContractSignOptionName = (type?: ContractSignOption) => {
    const found = ContractSignOptions.find(x => x[0] === type)
    return found ? found[1] : undefined
}